
import { Platform } from "react-native";

const SAFE_IMAGE_FORMATS = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
];
const PLACEHOLDER_IMAGE = require('../../assets/images/article_placeholder.png');
function isSafeImageUrl(url = '') {
    try {
      const cleanUrl = url.split(/[?#]/)[0].toLowerCase();
      return SAFE_IMAGE_FORMATS.some(ext => cleanUrl.endsWith(`.${ext}`));
    } catch {
      return false;
    }
  }
  export const getImageUri = (imageUrl?: string) => {
    const valid =
      typeof imageUrl === "string" &&
      imageUrl.trim().length > 0 &&
      isSafeImageUrl(imageUrl);
  
    // Remote image (works everywhere)
    if (valid) {
      return { uri: imageUrl };
    }
  
    // Fallback handling
    if (Platform.OS === "web") {
      // Web expects uri string
      return { uri: PLACEHOLDER_IMAGE as string };
    }
  
    // Native expects require() object directly
    return PLACEHOLDER_IMAGE;
  };
  

  export const isSingleWord = (text: string) => {
    return text?.trim().split(/\s+/).length === 1;
  };

  export function debounce<T extends (...args: any[]) => Promise<any>>(
    fn: T,
    delay: number
  ) {
    let timer: ReturnType<typeof setTimeout>;
  
    return (...args: Parameters<T>): Promise<ReturnType<T>> => {
      return new Promise((resolve, reject) => {
        clearTimeout(timer);
  
        timer = setTimeout(async () => {
          try {
            const result = await fn(...args);
            resolve(result);
          } catch (err) {
            reject(err);
          }
        }, delay);
      });
    };
  }